// utils/token.ts

const decodePayload = (token: string): Record<string, any> | null => {
  try {
    const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
};
 
export const isTokenExpired = (token?: string | null): boolean => {
  if (!token) return true;
  const payload = decodePayload(token);
  if (!payload) return true; // malformed token
  if (!payload.exp) return false; // no exp claim, let the server decide
  return payload.exp * 1000 <= Date.now();
};

/** Milliseconds until the token expires (null if there is no exp claim). */
export const getTokenMsLeft = (token?: string | null): number | null => {
  if (!token) return null;
  const payload = decodePayload(token);
  if (!payload?.exp) return null;
  return payload.exp * 1000 - Date.now();
};